import type { FragmentOf } from "@opensea/graphql"
import { readFragment } from "@opensea/graphql"
import { bn } from "@opensea/utils"
import { CurrencyPriceDisplay } from "../../../CurrencyPrice"
import type { TokenSwapActivityType } from "../TokenSwapActivityTableRowContext"
import { TokenSwapPriceFragment } from "./TokenSwapPrice.fragment"

type Props = {
  activity: FragmentOf<typeof TokenSwapPriceFragment>
  type: TokenSwapActivityType
}

export function TokenSwapPrice({ activity: activityKey, type }: Props) {
  const activity = readFragment(TokenSwapPriceFragment, activityKey)

  const relevantTokenPrice =
    type === "sell"
      ? activity.fromToken
      : type === "buy"
        ? activity.toToken
        : activity.fromToken

  const swapPrice = bn(relevantTokenPrice.usd).dividedBy(
    relevantTokenPrice.token.unit,
  )

  return (
    <CurrencyPriceDisplay
      stableSignificantDigits
      value={swapPrice.toNumber()}
      withFullValueTooltip={false}
    />
  )
}
